<template>
  <el-container class="realPower">
    <!-- 实有力量 -->
    <el-card class="tree-card" :body-style="treeCard">
      <div class="button-icon">
        <span @click="iconClick(1)">
          <el-icon :size="15"> <plus /> </el-icon>新建
        </span>
        <span @click="iconClick(2)">
          <el-icon :size="15"> <delete /> </el-icon>删除
        </span>
        <span @click="iconClick(3)">
          <el-icon :size="15"> <edit /> </el-icon>编辑
        </span>
      </div>
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="id"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <h-unfold @refreshTableEmit="refreshTable()">
          <template #type>
            <h-selectcode
              type="sex"
              v-model="tableParams.sex"
              placeholder="性别"
              :clearable="true"
              :style="{ width: '300px' }"
            ></h-selectcode>
          </template>
          <el-form-item label="性别" prop="sex">
            <h-selectcode
              type="sex"
              v-model="tableParams.sex"
              placeholder="性别"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="民族" prop="nation">
            <h-selectcode
              type="nationType"
              v-model="tableParams.nation"
              placeholder="民族"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="文化程度" prop="education">
            <h-selectcode
              type="educationType"
              v-model="tableParams.education"
              placeholder="文化程度"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item>
            <h-button type="primary" @click="refreshTable">查询</h-button>
            <h-button @click="resetForm(formRef)">重置</h-button>
          </el-form-item>
        </h-unfold>
        <el-row :style="{ 'margin-top': '10px' }">
          <!-- <el-select
              :disabled="currentNode.type !== 'pp'"
              @change="selectChange"
              placeholder="新建"
            >
              <el-option
                v-for="item in [
                  { value: '1', label: '选择实有人' },
                  { value: '2', label: '新建力量' },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>-->
          <!-- <el-dropdown
              split-button
              type="primary"
            >
              新建
              <template #dropdown>
                <el-dropdown-menu placeholder="新建">
                  <el-dropdown-item
                    v-for="item in [
                      { value: '1', label: '选择实有人' },
                      { value: '2', label: '新建力量' },
                    ]"
                    :key="item.value"
                    @click="selectChange(item)"
                  >{{ item.label }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown> -->
          <el-dropdown style="margin-right: 16px">
            <h-button type="primary"
              >新建
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </h-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="item in [
                    { value: '1', label: '选择实有人' },
                    { value: '2', label: '新建力量' },
                  ]"
                  :key="item.value"
                  @click="selectChange(item)"
                  >{{ item.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <h-button type="danger" @click="delUser">删除</h-button>
          <!-- <h-button type="primary" @click="uploade">导入</h-button>
            <h-button type="primary" @click="exporting">导出当前页</h-button>
            <h-button type="primary" @click="exportingAll">导出全部</h-button>
            <h-button type="primary" @click="download">模板下载</h-button>
            <input type="file" v-show="false" ref="file" @change="myup" /> -->
          <el-dropdown>
            <h-button type="primary" :style="{ marginLeft: '10px' }"
              >导入导出
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </h-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="uploade">导入</el-dropdown-item>
                <el-dropdown-item @click="exporting">导出</el-dropdown-item>
                <el-dropdown-item @click="exportingAll"
                  >导出全部</el-dropdown-item
                >
                <el-dropdown-item @click="download">下载模板</el-dropdown-item>
                <input type="file" v-show="false" ref="file" @change="myup" />
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="strengthlist"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #name="{ row }">
            <span v-if="row.prisonInfo">{{ row.prisonInfo.name }}</span>
          </template>
          <template #sexDict="{ row }">
            <span v-if="row.prisonInfo">{{ row.prisonInfo.sexDict }}</span>
          </template>
          <template #cardNumber="{ row }">
            <span v-if="row.prisonInfo">{{ row.prisonInfo.cardNumber }}</span>
          </template>
          <template #nationDict="{ row }">
            <span v-if="row.prisonInfo">{{ row.prisonInfo.nationDict }}</span>
          </template>
          <template #telphone="{ row }">
            <span v-if="row.prisonInfo">{{ row.prisonInfo.telphone }}</span>
          </template>
          <template #updateTime="{ row }">
            <span v-if="row.prisonInfo">{{ row.prisonInfo.updateTime }}</span>
          </template>
          <template #educationDict="{ row }">
            <span v-if="row.prisonInfo">{{
              row.prisonInfo.educationDict
            }}</span>
          </template>
          <template #houseAddress="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span :style="{ 'white-space': 'pre-wrap' }">{{
                row.prisonInfo.houseAddress
              }}</span>
            </div>
          </template>
          <template #strengthGroupName="{ row }">
            <span v-if="row.prisonInfo">
              {{ row.strengthGroupName }}
            </span>
          </template>
        </h-table>
      </div>
    </el-card>
  </el-container>
  <el-dialog
    v-model="iconVisible.iconformVisible"
    :title="iconVisible.title"
    width="20%"
  >
    <el-input v-model="iconVisible.name" size="small"></el-input>
    <div style="text-align: center; margin-top: 50px">
      <h-button type="primary" @click="determine()">确定</h-button>
      <h-button @click="iconVisible.iconformVisible = false">取消</h-button>
    </div>
  </el-dialog>
  <el-dialog
    v-model="houseTwoSYRVisible"
    title="选择实有人口"
    width="43%"
    height="40vh"
  >
    <houseTwoSYR
      v-if="houseTwoSYRVisible"
      v-model="houseTwoSYRVisible"
      @submitList="submitList"
      :form="userFormData"
      :status="formStatus"
      @submit="userSubmit"
    ></houseTwoSYR>
  </el-dialog>
  <el-dialog
    v-model="houseTwoJZRVisible"
    :title="
      '人口' + (formStatus === 1 ? '新增' : formStatus === 2 ? '编辑' : '详情')
    "
    width="43%"
    height="40%"
  >
    <personnel-detail
      @clone="clone"
      v-if="houseTwoJZRVisible"
      v-model="houseTwoJZRVisible"
      :form="userFormData"
      :row="userRowData"
      :status="formStatus"
      :strengthShow="true"
      :addAndAdd="true"
      :currentRegion="currentNodeItem"
      @submit="userSubmit"
    ></personnel-detail>
  </el-dialog>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { ArrowDown, Edit, Plus, Delete } from "@element-plus/icons-vue";
import {
  strengthlist,
  strengthgroupsave,
  strengthgroupupdate,
  strengthgroupdelete,
  strengthgrouplist,
  strengthsave,
  strengthinfodelete,
} from "@/api/threeSolid/threeSolid.js";

import {
  uploadpower,
  derivepower,
  downloadpower,
  getMenutree,
} from "@/api/system/region.js";
import houseTwoSYR from "./components/houseTwoSYR.vue";
import _ from "lodash";
export default defineComponent({
  name: "realPower",
  components: { Edit, Plus, Delete, houseTwoSYR, ArrowDown },
  props: {},
  setup(props) {
    const state = reactive({
      tableSelection: [],
      filterText: "",
      rootNodeKey: "",
      iconIndex: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      userRowData: {},
      tableParams: {
        regionId: "",
        education: "",
        groupId: "",
      },
      currentNode: {},
      currentNodeItem: {},
      arrNode: [],
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      iconVisible: {
        iconformVisible: false,
        name: "",
        title: "",
      },
      houseTwoSYRVisible: false, // 实有人
      houseTwoJZRVisible: false, // 居住人
      columns: [
        { type: "selection" },
        {
          label: "姓名",
          slot: "name",
          width: "80px",
        },
        {
          label: "性别",
          slot: "sexDict",
          width: "80px",
        },
        {
          label: "证件号码",
          slot: "cardNumber",
        },
        {
          label: "民族",
          slot: "nationDict",
        },
        {
          label: "文化程度",
          slot: "educationDict",
        },
        {
          label: "力量类型",
          slot: "strengthGroupName",
        },

        {
          label: "联系电话",
          slot: "telphone",
        },
        {
          label: "更新时间",
          slot: "updateTime",
        },
        {
          label: "居住地址",
          slot: "houseAddress",
          width: "270px",
        },
        {
          type: "operate",
          label: "操作",
          width: "100px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
    });
    const file = ref();
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      if (item.type !== "pp") {
        state.currentNodeItem = item;
        // state.tableParams.groupId
      }
      if (item.type === "pp") {
        state.tableParams.groupId = item.id;
      } else {
        state.tableParams.regionId = item.id;
        state.tableParams.groupId = "";
      }
      state.currentNode = item;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 树的递归提取
    const recursion = (data, arr) => {
      (data.children || []).forEach((child) => {
        if (child.type === "1") {
          arr.push(child);
        } else if (child.children && child.children.length > 0) {
          recursion(child, arr);
        }
      });
      return arr;
    };
    // 社区后面的数据
    const strengthgrouplistAxios = async (dataSource) => {
      const params = {
        limit: 200,
      };
      const data = await strengthgrouplist(params);

      state.arrNode = data.page.list;
      const arr = [];
      recursion(dataSource[0], arr);
      arr.forEach((item, index) => {
        item.children = [];
        if (item.type === "1") {
          state.arrNode.forEach((items) => {
            if (items.regionId === item.id) {
              item.children.push({
                id: items.groupId,
                name: items.groupName,
                treeId: "",
                type: "pp",
              });
            }
          });
        }
      });
    };

    // 获取结构树
    const queryOrganTreAsync = async () => {
      const params = {
        type: "1",
      };
      const result = await getMenutree(params);
      const treeData = [result.data];
      await strengthgrouplistAxios(treeData);
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.id;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
        state.rootNodeKey = treeData[0].children[0].id;
      }
    };
    queryOrganTreAsync();
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      console.log(row, 123123);
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row.prisonInfo);
        state.userRowData = _.cloneDeep(row);
        // state.userFormData.roleIdList = row.roleList.map(item => item.roleId);
        state.houseTwoJZRVisible = true;
        nextTick(() => {});
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该实有力量吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.strengthId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    const deleteUserAsync = async (ids) => {
      const res = await strengthinfodelete(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的实有力量吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.strengthId);
            deleteUserAsync(ids);
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的实有力量",
        });
      }
    };
    // 选择然后选择对应的弹框
    const selectChange = (val) => {
      // 1选择实有人 2新建居住人
      if (val.value === "1") {
        state.houseTwoSYRVisible = true;
      } else {
        state.userFormData = {};
        state.houseTwoJZRVisible = true;
        state.formStatus = 1;
      }
    };
    // 1新建  2删除  3编辑
    const iconClick = async (is) => {
      state.iconIndex = is;
      if (is === 1) {
        if (state.currentNode.type === "1" || state.currentNode.type === "pp") {
          state.iconVisible.iconformVisible = true;
          state.iconVisible.title = "新建";
        } else {
          ElMessage({
            type: "warning",
            message: "请先选择社区",
          });
        }
      } else if (is === 2) {
        if (state.currentNode.type === "pp") {
          ElMessageBox.confirm("您确认要删除该菜单吗？", "删除", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(
            async () => {
              if (state.currentNode.type === "pp") {
                await strengthgroupdelete([state.tableParams.groupId]);
                await strengthgrouplistAxios(state.dataSource);
              } else {
                ElMessage({
                  type: "warning",
                  message: "请先选择楼栋",
                });
              }
            },
            () => {}
          );
        } else {
          ElMessage({
            type: "warning",
            message: "请先选择楼栋",
          });
        }
      } else {
        if (state.currentNode.type === "pp") {
          state.iconVisible.iconformVisible = true;
          state.iconVisible.name = state.currentNode.name;
          state.iconVisible.title = "编辑";
        } else {
          ElMessage({
            type: "warning",
            message: "请先选择楼栋",
          });
        }
      }
    };
    const determine = async (data) => {
      let res;
      if (state.iconIndex === 1) {
        if (state.iconIndex === 1) {
          const params = {
            regionId: state.tableParams.regionId,
            groupName: state.iconVisible.name,
          };
          res = await strengthgroupsave(params);
          if (res.code === 0) {
            ElMessage.success("添加成功");
            await strengthgrouplistAxios(state.dataSource);
            state.iconVisible.iconformVisible = false;
            state.iconVisible.name = "";
          }
        }
      } else if (state.iconIndex === 3) {
        const params = {
          groupId: state.tableParams.groupId,
          groupName: state.iconVisible.name,
        };
        res = await strengthgroupupdate(params);
        if (res.code === 0) {
          ElMessage.success("修改成功");
          await strengthgrouplistAxios(state.dataSource);
          state.iconVisible.iconformVisible = false;
          state.iconVisible.name = "";
        }
      }
    };
    const submitList = async (val) => {
      val.forEach(async (item) => {
        console.log(item, 66666);
        const params = {
          prisonId: item.prisonId, // 人id
          regionId: state.currentNodeItem.id, // 父id
          // strengthGroupId: state.currentNode.id, // 对应社区下面的id
          strengthGroupId: item.strengthGroupId, // 对应社区下面的id
        };
        const res = await strengthsave(params);
        if (res.code === 0) {
          ElMessage.success("修改成功");
          refreshTable();
        }
      });
      // tableRef.value.tableData = tableRef.value.tableData.concat(val);
    };
    // 导入
    const uploade = () => {
      file.value.click();
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("chunk", "0"); // 添加form表单中其他数据
      console.log(file.name);
      var filename = file.name;
      var excelname = filename.substring(filename.lastIndexOf("."));
      console.log(excelname);
      if (excelname != ".xls" && excelname != ".xlsx") {
        alert("请先下载模板后再上传!");
      } else {
        const result = await uploadpower(param);
        if (result.code == 0) {
          ElMessage({
            type: "success",
            message: "上传成功",
          });
          refreshTable();
        }
        console.log("result", result);
      }
    };
    // 下载模板
    const download = async () => {
      window.open(window.xlsxUrl + "实有力量信息导入模板.xlsx");
    };
    // 导出
    const exporting = async () => {
      const res = await derivepower(tableRef.value.form);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "c",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    // 导出全部
    const exportingAll = async () => {
      const params = {
        allowpage: true,
      };
      const res = await derivepower(params);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    return {
      ...refData,
      submitList,
      selectChange,
      determine,
      iconClick,
      filterNode,
      currentChange,
      tableRef,
      refreshTable,
      resetForm,
      delUser,
      hzTableSelect,
      handleClick,
      strengthlist,
      userSubmit,
      formRef,
      uploade,
      myup,
      download,
      exporting,
      exportingAll,
      file,
      queryOrganTreAsync,
    };
  },
});
</script>
<style lang="scss" scoped>
.realPower {
  height: 100%;
  .tree-card {
    height: 100%;
    width: 300px;
    .button-icon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      span {
        display: display;
        align-items: center;
        padding: 5px 15px;
        cursor: pointer;
      }
      span:hover {
        background-color: #ecf5fd;
      }
    }
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .el-tree-input {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        background-color: var(--el-color-info-lighter);
        box-sizing: border-box;
        border-color: transparent;
        border-radius: 5px;
        margin: 2px 0 2px 6px;
        text-align: center;
      }
    }
  }
}
</style>
